module.exports = __webpack_public_path__ + "img/theblock.4e701e42.png";